<template >
<div class="container py-5 px-5" v-if="lesson">


      <div class="card mb-4" v-for="(group) in groups"  v-if="groups && groups.length>0">
        <div class="card-header py-3">
          <div class="row">
            <div class="col">
              <h3 class="m-0 font-weight-bold text-primary">{{group.schoolName}}</h3>
            </div>

          </div>
        </div>
        <div class="card-body" >
          <div class="my-3">
            <h5 class="m-0 font-weight-bold text-primary"> 
              <span v-if="group.group">{{group.groupName}}</span>
              <span v-if="group.program">{{group.departmentName}} - {{group.programName}}</span>
            </h5>
          </div>
          <table class="table table-bordered table-condensed table-hover table-striped" id="dataTable" width="100%" cellspacing="0" v-if="group.students && group.students.length>0">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Овог/нэр</th>
                  <th class="font-weight-normal" v-if="topics && topics.length>0" v-for="topic in group.topics">
                    {{topic.date | formatDate}}
                    <br/>
                    <span v-if="log">Хичээл орох: <span class="font-weight-bold">{{log.line}} ээлж , {{log.time}} -р цаг</span></span><br/>
                    <span v-if="topic && topic.teachedByData">
                      Хичээл заасан: <span class="font-weight-bold">{{topic.teachedByData.name}} - {{topic.teachedByData.email}}</span>
                      <span class="badge badge-info text-md mx-2" v-if="topic.replace==true">орлож заасан</span>
                    </span>
                    <br/>
                    <span v-if="topic && topic.startDate">Эхэлсэн: <span class="font-weight-bold">{{topic.startDate | formatDate}}</span></span>
                    <br/>
                    <span v-if="topic && topic.hozorson">Хоцорсон: <span class="font-weight-bold">{{topic.hozorson}} минут</span></span><br/>
                    <span v-if="topic && topic.ipaddress" class="text-danger">Бүртгэсэн IP хаяг: {{topic.ipaddress}}</span>
                    
                    
                    <br/>
                    <button v-if="topic && !topic.startDate" class="btn btn-sm btn-success" @click="setForTeacher(topic, group)">цаг бүртгүүлэх</button>
                  </th>

                  <!-- <th>Төлөв</th> -->
                  <!-- <th>Үйлдэл</th> -->

                </tr>
              </thead>

              <tbody>
                <tr v-for="(std, index) in group.students" v-bind:key="std.id">
                  <td>{{index+1}}</td>
                  <td>
                    <span v-if="std!=null">
                      <span v-if="std.lastname && std.lastname.length>0">
                        <span v-if="std.lncount && std.lncount>1 && std.lastname.length>=std.lncount">{{std.lastname.substring(0, std.lncount)}}</span>
                        <span v-else>{{std.lastname[0]}}</span>.

                      </span>
                      {{std.name}}
                    </span><br/>
                    <!-- <span v-if="std!=null">{{std.code}}</span><br/> -->
                    <!-- <span v-if="std!=null">{{std.register}}</span> -->
                  </td>
                  <td v-if="std && std.topics" v-for="stTopic in std.topics">

                    <span v-if="stTopic && stTopic.attendance && stTopic.attendance.status" class="text-white">

                      <div style="cursor:pointer" v-if="stTopic.attendance.status=='active'" class="badge badge-pill bg-success" @click="deleteForStudent(stTopic.attendance.status, stTopic, std, index, index, group)">суусан</div>
                      <div style="cursor:pointer"  v-if="stTopic.attendance.status=='off'" class="badge badge-pill bg-danger" @click="deleteForStudent(stTopic.attendance.status, stTopic, std, index, index, group)">суугаагүй</div>
                      <div style="cursor:pointer"  v-if="stTopic.attendance.status=='ill'" class="badge badge-pill bg-info" @click="deleteForStudent(stTopic.attendance.status, stTopic, std, index, index, group)">өвчтэй</div>
                      <div style="cursor:pointer"  v-if="stTopic.attendance.status=='release'" class="badge badge-pill bg-warning" @click="deleteForStudent(stTopic.attendance.status, stTopic, std, index, index, group)">чөлөөтэй</div>
                      <!-- <i class="fas fa-trash text-danger" style="cursor:pointer" @click="deleteForStudent(stTopic.attendance.status, stTopic, std, index, index, group)"></i>
                                     -->
                      
                    </span>
                    <span v-else>
                      <span style="cursor:pointer" class="badge badge-pill badge-success mr-1" @click="setForStudent('active', stTopic, std, index, index, group)">суусан</span>
                      <span style="cursor:pointer" class="badge badge-pill badge-danger mr-1" @click="setForStudent('off', stTopic, std, index, index, group)">суугаагүй</span>
                      <span style="cursor:pointer" class="badge badge-pill badge-info mr-1" @click="setForStudent('ill', stTopic, std, index, index, group) ">өвчтэй</span>
                      <span style="cursor:pointer" class="badge badge-pill badge-warning mr-1" @click="setForStudent('release', stTopic, std, index, index, group)">чөлөөтэй</span>
                    </span>
                  </td>

                  <!-- <td>
                    <span v-if="std.enabled==true" class="badge badge-pill badge-success">идэвхтэй</span>
                    <span v-else class="badge badge-pill badge-danger">блоклосон</span>
                  </td> -->
                  <!-- <td> -->

                    <!-- <button class='btn btn-sm btn-danger' @click="removeStudent(std)">хасах</button>
                    <button v-if="std.enabled==true" class='btn btn-sm btn-primary  mx-1' @click="setEnabledForStudent(std, false)">эрх хаах</button>
                    <button v-else class='btn btn-sm btn-primary mx-1' @click="setEnabledForStudent(std, true)">эрх нээх</button> -->
                  <!-- </td> -->
                </tr>
                
              </tbody>
            </table>
          

        </div>
      </div>
      <div v-else class="alert alert-warning text-center mb-4"><h4>Та одоогоор ямар нэгэн сэдэв оруулаагүй байна.</h4></div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Анги нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
    
         
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="_addProgram" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </div>


</div>
    
</template>

<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import VueQrcode from 'vue-qrcode';
import LessonInfo from '../shared/LessonInfo';
export default {
    name: "ILessonGroupStudents",

    data() {
        return {
            lesson: null,
            topics:[],
            selectedType:null,
            studentsText:'',
            selectedTopic:null,
            tmpStudents:[],

            display:0,
            tagText:null,
            schools:[],
            school:null,
            department:null,
            program:null,
            groups:[],
            first:true,
            log:null
            
        };
    },
    methods: {
        
      async _getQA(){
        this.topics=[];
        this.groups=[];
        var doc=await fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).get();
        let lesson=doc.data();
        lesson.id=doc.id;
        
        await this._getTopics();

        if(this.log && this.log.program &&  lesson && lesson.groups && lesson.groups.length>0){
          var tmp=[];
          for(const group of lesson.groups){
            if(group.program.id==this.log.program.id){
              group.id=group.program.id;
              group.students=[];
              group.topics=[];
              for(const topic of this.topics){
                let item= Object.assign({}, topic);
                item.attendance=null;
                group.topics.push(item);
                
                if(!item.checked || (item.checked && item.checked==false)){
                  this.setCheckedForTopic(group, item);
                  
                }
              }
              this._getStudents(group);
              tmp.push(group);

            }
          }

          this.groups=tmp;

        }
        else if(this.log && this.log.group &&  lesson && lesson.lessonGroups && lesson.lessonGroups.length>0){
          var tmp=[];
    
          for(const group of lesson.lessonGroups){
            if(group.group.id==this.log.group.id){
              group.id=group.group.id;
              group.students=[];
              group.topics=[];
              group.isGroup=true;
              for(const topic of this.topics){
                let item= Object.assign({}, topic);
                item.attendance=null;
                group.topics.push(item);
                if(!item.checked || (item.checked && item.checked==false)){
                  this.setCheckedForTopic(group, item);
                  
                }
              }
              this._getStudents(group);
              tmp.push(group);

            }
          }
          this.groups=tmp;

        }

        this.lesson=lesson;

      },
      async _getStudents(group){
        var snapshot;
        if(group.isGroup && group.isGroup==true){
          snapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("lessonGroups", "array-contains", group.group).orderBy("name").get();
        
        }
        else
          snapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("program", "==", group.program).orderBy("name").get();
        // var checkedStudent=true;
        
        for(const studentDoc of snapshot.docs){
          if(studentDoc.exists){
            let student=studentDoc.data();
            student.id=studentDoc.id;
            student.ref=studentDoc.ref;
            student.topics=[];

            for(const topic of this.topics){
              // if(!topic.checked || (topic.checked && topic.checked==false)){
              //   checkedStudent=false;
                
              // }
              let item= Object.assign({}, topic);
              item.attendance=null;
              // if(checkedStudent!=true){
              //   await this.setForStudent('active', item, student, null, null, group);
              // }
              fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/logs/"+topic.id+"/logattendance/"+studentDoc.id).onSnapshot(atDoc=>{
                if(atDoc.exists){
                  let atItem=atDoc.data();
                  atItem.id=atDoc.id;
                  atItem.ref=atDoc.ref;
                  item.attendance=atItem;
                }
              });

              student.topics.push(item);
            }
            group.students.push(student);
          }
        }


      },
      async setCheckedForTopic(group, topic){
        var snapshot;
        if(group.isGroup && group.isGroup==true)
          snapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("lessonGroups", "array-contains", group.group).get();
        else
          snapshot=await fb.db.collection("schools/"+this.schoolId+"/students").where("program", "==", group.program).get();
        var checkedStudent=true;
        
        for(const studentDoc of snapshot.docs){
          if(studentDoc.exists){
            let student=studentDoc.data();
            student.id=studentDoc.id;
            student.ref=studentDoc.ref;

            if(!topic.checked || (topic.checked && topic.checked==false)){
              checkedStudent=false;  
            }
            let item= Object.assign({}, topic);
            item.attendance=null;
            if(checkedStudent!=true){
              await this.setForStudent('active', item, student, null, null, group);
            }

          }
        }

        if(checkedStudent!=true){
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/logs/"+topic.id).update({checked:true});
          this.setForTeacher(topic, group);
        }
        
      },
      async _getTopics(){

        var lsnapshot=await fb.db.collection("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/logs").doc(this.logId).get();
        this.topics=[];
        // for(const topicDoc of snapshot.docs){
          if(lsnapshot.exists){
            let topic=lsnapshot.data();
            topic.ref=lsnapshot.ref;
            topic.id=lsnapshot.id;
            topic.teachedByData=null;
            if(topic.teachedBy){
              var tdoc=await topic.teachedBy.get();
              topic.teachedByData=tdoc.data();
            }
            this.topics.push(topic);
            this.log=topic;

          }
        // }
      },

      _addTopic(){
        this.school=null;
        this.department=null;
        this.program=null;
        $('#exampleModal').modal('toggle');
      },
      async deleteForStudent(old, topic, student, stindex, index, group){
        var tmpTopic=null;

        this.setProperty("status", fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/logs/"+topic.id+"/logattendance/"+student.id), null);
        if(topic.attendance.status=="active"){
          var tmp={"numberOfArrived": fb.firestore.FieldValue.increment(-1)};
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/logs/'+topic.id).update(tmp);
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update(tmp);
          
          if(student.ref)
            student.ref.update(tmp);
          if(group && group.program){
            group.program.update(tmp);
          }
        }
        else if(topic.attendance.status=="off"){
          var tmp={
            "numberOfNotArrived": fb.firestore.FieldValue.increment(-1),
            "numberOfOff": fb.firestore.FieldValue.increment(-1)
          };
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/logs/'+topic.id).update(tmp);
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update(tmp);

          if(student.ref)
            student.ref.update(tmp);
          if(group && group.program){
            group.program.update(tmp);
          }
        }
        else if(topic.attendance.status=="ill"){
          var tmp={
            "numberOfNotArrived": fb.firestore.FieldValue.increment(-1),
            "numberOfIll": fb.firestore.FieldValue.increment(-1)
          };
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/logs/'+topic.id).update(tmp);
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update(tmp);

          if(student.ref)
            student.ref.update(tmp);
          if(group && group.program){
            group.program.update(tmp);
          }
        }
        else if(topic.attendance.status=="release"){
          var tmp={
            "numberOfNotArrived": fb.firestore.FieldValue.increment(-1),
            "numberOfRelease": fb.firestore.FieldValue.increment(-1)
          };
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/logs/'+topic.id).update(tmp);
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update(tmp);

          if(student.ref)
            student.ref.update(tmp);
          if(group && group.program){
            group.program.update(tmp);
          }
        }
      },
      async setForStudent(value, topic, student, stindex, index,group){

        this.setProperty("status", fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/logs/"+topic.id+"/logattendance/"+student.id), value);

        if(value=="active"){
          var tmp={
            'lastChecked':new Date(),
            "numberOfArrived": fb.firestore.FieldValue.increment(1),
            'checkedTopics': fb.firestore.FieldValue.arrayUnion(topic.id),
          };
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/logs/'+topic.id).update(tmp);
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update(tmp);

          if(student.ref)
            student.ref.update(tmp);
          if(group && group.program){
            group.program.update(tmp);
          }
        }
        else if(value=="off"){
          var tmp={
            'lastChecked':new Date(),
            "numberOfNotArrived": fb.firestore.FieldValue.increment(1),
            "numberOfOff": fb.firestore.FieldValue.increment(1),
            'checkedTopics': fb.firestore.FieldValue.arrayUnion(topic.id)
          };
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/logs/'+topic.id).update(tmp);
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update(tmp);

          if(student.ref)
            student.ref.update(tmp);
          if(group && group.program){
            group.program.update(tmp);
          }
        }
        else if(value=="ill"){
          var tmp={
            'lastChecked':new Date(),
            "numberOfNotArrived": fb.firestore.FieldValue.increment(1),
            "numberOfIll": fb.firestore.FieldValue.increment(1),
            'checkedTopics': fb.firestore.FieldValue.arrayUnion(topic.id)
          };
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/logs/'+topic.id).update(tmp);
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update(tmp);

          if(student.ref)
            student.ref.update(tmp);
          if(group && group.program){
            group.program.update(tmp);
          }
        }
        else if(value=="release"){
          var tmp={
            'lastChecked':new Date(),
            "numberOfNotArrived": fb.firestore.FieldValue.increment(1),
            "numberOfRelease": fb.firestore.FieldValue.increment(1),
            'checkedTopics': fb.firestore.FieldValue.arrayUnion(topic.id)
          };
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/logs/'+topic.id).update(tmp);
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId).update(tmp);

          if(student.ref)
            student.ref.update(tmp);
          if(group && group.program){
            group.program.update(tmp);
          }
        }
      },

      async setForTeacher(topic, group){
        var now=new Date();
        var dateobject=null;
        try{
          var response=await this.$http.get('https://worldtimeapi.org/api/timezone/Asia/Ulaanbaatar');
          if(response && response.body && response.body.datetime){
            now=new Date(response.body.datetime);
            dateobject=response.body;

          }
        }
        catch(e){
          console.log(e);
        }
        
        var mnow=moment(now);
        if(topic && topic.line && topic.time){
          var timeDoc=await fb.db.collection("timetable").doc(topic.line+"-"+topic.time).get();
          if(timeDoc && timeDoc.exists && timeDoc.data() && timeDoc.data().time){
            var arr=timeDoc.data().time.split(":");
            if(arr && arr.length>1){
              var abc=new Date(now.getFullYear(), now.getMonth(), now.getDate(),arr[0] , arr[1], 0);

              if(now>abc){
                var duration = moment.duration(mnow.diff(abc));
                var minutes = duration.asMinutes();

                if(minutes>0){
                  if(topic.ref){
                    topic.ref.update({
                      startDate: now,
                      hozorson: parseInt(minutes.toString()),
                      teachedBy: this.userProfile.customer
                    });
                    this.addLateMinute(parseInt(minutes.toString()), group, topic);
                  }
                }
                else{
                  if(topic.ref){
                    topic.ref.update({
                      startDate: now,
                      hozorson: 0,
                      teachedBy: this.userProfile.customer
                    });
                    this.addLateMinute(0, group, topic);
                  }
                }
              }
            }
          }

          
        }
        this.checkTeacher(this.userProfile.customer, topic);

        this.setDefultTime(topic, group,now, dateobject);
    
        // this.setProperty("status", fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+'/studentList/'+student.id+"/attendance/"+topic.id), value);
     
      },
      checkTeacher(teacher, topic){
        if(this.lesson && teacher){
          var exists=false;
          if(this.lesson.teacherRefs && this.lesson.teacherRefs.length>0){
            for(const tref of this.lesson.teacherRefs){
              if(tref && tref.path==teacher.path){
                exists=true;
                break;
              }
            }
          }

          if(exists==false){
            var batch=fb.db.batch();
            batch.update(
              topic.ref,
              {
                replace:true
              }
            );
            batch.set(
              teacher.collection("replace_lessons").doc(),
              {
                lesson: fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId),
                teacher: teacher,
                createdAt: new Date(),
                log: topic.ref
              }
            );
            batch.commit();
          }
        }
      },
      async setDefultTime(topic, group,now, dateobject){

        if(topic.ref){
          await topic.ref.update({
            startDate: now,
            teachedBy: this.userProfile.customer,
            day: dateobject && dateobject.day_of_week?dateobject.day_of_week:null,
            week_number:dateobject && dateobject.week_number?dateobject.week_number:null,
            ipaddress:dateobject && dateobject.client_ip?dateobject.client_ip:null
          });
          this.addLateMinute(0, group, topic);
        }
        else{
          await fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/logs/"+topic.id).set({
            startDate: now,
            teachedBy: this.userProfile.customer,
            day: dateobject && dateobject.day_of_week?dateobject.day_of_week:null,
            week_number:dateobject && dateobject.week_number?dateobject.week_number:null,
            ipaddress:dateobject && dateobject.client_ip?dateobject.client_ip:null
          });

          this.addLateMinute(0, group, topic);
        }
        this._getQA();
      },
      async addLateMinute(minute, group, topic){
        var batch=fb.db.batch();
        batch.update(
          fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId),
          {
            hozorson: fb.firestore.FieldValue.increment(minute)
          }
        );
        topic.hozorson=minute;
        // batch.update(
        //   fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId+"/logs/"+topic.id),
        //   {
        //     hozorson: fb.firestore.FieldValue.increment(minute)
        //   }
        // );

        batch.update(
          this.userProfile.customer,
          {
            hozorson: fb.firestore.FieldValue.increment(minute)
          }
        );
        var tldoc=await this.userProfile.customer.collection("teacher_lessons").doc(this.lessonId).get();
        if(tldoc.exists)
          batch.update(
            this.userProfile.customer.collection("teacher_lessons").doc(this.lessonId),
            {
              hozorson: fb.firestore.FieldValue.increment(minute),
              lesson: fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId)
            }
          );
        else
          batch.set(
            this.userProfile.customer.collection("teacher_lessons").doc(this.lessonId),
            {
              hozorson: minute,
              lesson: fb.db.doc("schools/"+this.schoolId+"/lessons/"+this.lessonId)
            }
          );

        batch.commit();

      },

      setEnabledForStudent(stddata, value){
        this.setProperty("enabled", stddata.ref, value);
        this.setProperty("enabled", fb.db.doc("schools/"+this.schoolId+"/students/"+stddata.id+"/lessonList/"+this.lessonId), value);
        
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.set(tmp, {merge:true});
        }
      },
      removeStudent(stddata){
        fb.db.doc("schools/"+this.schoolId+"/students/"+stddata.id+"/lessonList/"+this.lessonId).delete();
        stddata.ref.delete();
        fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).update({
          'numberOfStudents': fb.firestore.FieldValue.increment(-1)
        });

      },
 


        _addProgram(){
          if(this.school!=null && this.school!=undefined && this.department!=null && this.department!=undefined && this.program!=null && this.program!=undefined){
            var exists=false;
            if(this.lesson!=null && this.lesson!=undefined && this.lesson.groups!=null && this.lesson.groups!=undefined && this.lesson.groups.length>0){
              for(const tmp of this.lesson.groups){
                if(tmp!=null && tmp!=undefined && tmp.program!=null && tmp.program!=undefined && tmp.program.id==this.program.id){
                  exists=true;
                }
              }
            }
            if(exists==false){
              fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id).update({
                groups: fb.firestore.FieldValue.arrayUnion(
                  {
                    school: this.school.ref,
                    department: this.department.ref,
                    program: this.program.ref,
                    schoolName: this.school.data().name,
                    departmentName: this.department.data().name,
                    programName: this.program.data().name
                  }
                )
              });
              this.findStudents(this.school.ref, this.department.ref, this.program.ref);
            }
            else{
              alert("Аль хэдийн нэмэгдсэн байна.");
            }
          }
          else{
            alert("Та мэдээллээ бүрэн оруулна уу.");
          }
        },
        findStudents(sc, dep, pro){
          fb.db.collection("schools/"+this.schoolId+"/students").where("school", "==", sc).where("department", "==", dep).where("program", "==", pro).get().then(docs=>{
            for(const studentData of docs.docs){
              
              if(studentData!=null && studentData.exists){
                var studentDetail=studentData.data();
                this.addStudentToLesson(fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lesson.id), studentData, studentDetail);
              }
            }
          });
        }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    components: {
      VueQrcode,
      LessonInfo
    },
    props: {
      schoolId:{
        required:true
      },
      lessonId: { 
          required: true,
      },
      logId:{
        required:true
      }

    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!=''){
          this._getQA();
        }
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm:ss');
      },
    }
  
};
</script>

